export default __webpack_public_path__ + "static/media/MercadoNacional_ZH.c42e24b0.jpg";